import React, { useState, useEffect } from "react";
import moment from "moment";
import { Group, Text } from "@mantine/core";
import { getDuration } from "../Common/util";

const PaymentCountdown = (props) => {
  const { next, locale, language, isModal, isNotification } = props;
  const [time, setTime] = useState(moment());

  useEffect(() => {
    const interval = window.setInterval(() => setTime(moment()), 1000);
    return window.clearInterval(interval);
  }, []);

  if (!next) {
    return <div />;
  }

  const localDiff = getDuration(time.diff(next), locale, language);
  const text = `${localDiff}`;

  return (
    <>
      {isModal ? (
        <Text style={{ fontSize: "1.35rem" }} weight={500}>
          {text}
        </Text>
      ) : isNotification ? (
        <Text
          style={{ fontSize: "1rem" }}
          sx={(theme) => ({
            color: theme.colors.gray[9],
          })}
        >
          {language.hasToPay} <span role="timer">{text}</span>
        </Text>
      ) : (
        <Group spacing={0}>
          <Text
            style={{
              fontSize: "1rem",
              padding: "0.5rem 0.6rem",
              color: "white",
            }}
          >
            {language.hasToPay}:
          </Text>
          <Text style={{ fontSize: "1rem", color: "white" }} weight={500}>
            {text}
          </Text>
        </Group>
      )}
    </>
  );
};

export default PaymentCountdown;
